// @ts-ignore
import shop from 'shopify-buy'

export default shop.buildClient({
  domain: "offlimits-cereal.myshopify.com",
  storefrontAccessToken: "54cb6d2a342b55e87ae761c8bd845bea",
})
